import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { OverlayPanel } from 'primeng/overlaypanel';
import { ContactCardDto } from '@hub/generated/models';
import { AddressCardComponent } from './address-card.component';
import { AfterContentChecked } from '@angular/core';

@Component({
  selector: 'label-address-card',
  templateUrl: 'label-address-card.component.html'
})
export class LabelAddressCardComponent {
  @ViewChild(AddressCardComponent) contactCard: AddressCardComponent;
  @Input() card: any;
  @Input() text: string;
  @Input() iconType: string;

  showToggle(event) {
    this.contactCard.showContactCard(event, event.currentTarget);
  }

  hideContactCard() {
    this.contactCard.hideContactCard();
  }
}
